import types from './types'
import { createReducer } from "redux/handlers"

const initialState = {
  // Search status and data
  bookings: [],
  isLoading: true,
  isFailure: false,
  newFilters: {
    textToSearch: '',
    pnrLocator: '',
    page: 0,
    limit: 30,
    type: [],
    providers: [],
    brands: [],
    delegations: [],
    reservationStatus: [],
    bookedOn: ['', ''],
    bookedForDate: ['', ''],
    issueDateLimit: ['', ''],
    channels: [],
    sortByField: 'bookedOn',
    sortType: 'desc'
  },
  // Filters
  colsToShow: ['type', 'bookedOn', 'reservationStatus', 'passengerName', 'provider', 'pnrLocator', 'bookedForDate'],
  company: '',
  totalBookings: 0,
  checked:[],
}

export default createReducer(initialState, {
  [types.NEW_BOOKINGS_START_SEARCH](state, action) {
    return{ ...state, isLoading: true, isFailure: false }
  },
  [types.NEW_BOOKINGS_FAILURE_SEARCH](state, action) {
    return { ...state, isLoading: false, isFailure: true }
  },
  [types.NEW_BOOKINGS_SUCCESS_SEARCH](state, { payload }) {
    return {
      ...state,
      isLoading: false,
      isFailure: false,
      bookings: payload.results,
      totalBookings: payload.totalBookings,
    }
  },
  [types.NEW_BOOKINGS_UPDATED_FILTERS](state, action) {
    return { ...state,
      newFilters:{
        ...state.newFilters,
        ...action.field === 'brandsAndDelegations'
          ? {
            brands: action?.value?.brands || [],
            delegations:  action?.value?.delegations || []
          }
          :{ [action.field]: action.value }
      }
    }
  },
  [types.NEW_BOOKINGS_RESET_ALL_FILTERS](state, action) {
    return { ...state,
      newFilters: action.newFilters
    }
  },
  [types.NEW_BOOKINGS_UPDATED_COLS_FILTERS](state, action) {
    return { ...state, [action.field]: action.value }
  },
  [types.NEW_BOOKINGS_SELECT_BOOKING](state, payload) {
    return { ...state, checked: payload.bookingsId }
  },
})